// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

// Interfaces
import { IfcProductMinified } from 'Interfaces/ifcProductMinified';
import { IfcProduct } from 'Interfaces/ifcProduct';

//Render
import WithRender from "Components/Shared/ProductCard/product-card.html";

//API Service
import FavoritesService from "Services/favoritesService"

const noImage = `https://images.national-hardware.com/is/image/nh/noimage?$nhwProductThumbs$`;

@WithRender
@Component()

export default class ProductCard extends Vue {
	@Prop({}) displayName!: string;
	@Prop({}) productDetailUrl!: string;
	@Prop({}) availability!: string;
	@Prop({}) primaryImageUrl: string;
	@Prop({}) alternateFinishes: IfcProductMinified[];
	@Prop({}) finish: any;
	@Prop({}) translations: any;
	@Prop({}) productIndex: number;
	@Prop({}) secondaryImageUrl: string;
	@Prop({}) stockNumber: string;
     isFavorites: boolean;

	availabilityValues:any = {
		NEW: "New",
		DISCONTINUED: "Discontinued",
		COMINGSOON: "ComingSoon",
		ACTIVE: "Active"
	};

	created(){
		let vm = this;
		if(!vm.primaryImageUrl) {
			vm.primaryImageUrl = noImage;
		}
		vm.setFavorites(vm.stockNumber);
	}

	setFavorites(stockNumber:string)
	{
		let vm = this;
		let productIds = this.getFavoriteProducts();
            if (stockNumber != null) {
                if (productIds.indexOf(stockNumber) > -1) {
                    vm.isFavorites = true;
                } else {
                    vm.isFavorites = false;
                }
            }	
	}
	getFavoriteProducts(): string[] {
		let productIds: string[] = [];
		if (localStorage.getItem('favorite-products')) {
			productIds = JSON.parse(localStorage.getItem('favorite-products'));
		}
		return productIds;
	}	

	setProductCardFinish(e?:any, alternateFinish?:any) {
		let vm = this;
		e.preventDefault();
		vm.productDetailUrl = alternateFinish.productDetailUrl;
		vm.primaryImageUrl = alternateFinish.primaryImageUrl ? alternateFinish.primaryImageUrl : noImage;
		vm.secondaryImageUrl = alternateFinish.secondaryImageUrl;
		vm.finish = alternateFinish.finish;
		vm.availability = alternateFinish.availability;
		vm.displayName = alternateFinish.displayName;
	}
}

